import { DateTimeObject } from 'mobx/commonTypes';

const defaultDateTimeFormatter = (dtString: string) => {
  try {
    const [d, t] = dtString.split(' ');
    const [h, m, s] = t.split(':');

    if (
      d === undefined ||
      t === undefined ||
      h === undefined ||
      m === undefined ||
      s === undefined
    ) {
      throw new Error('Неверный формат даты');
    }

    return {
      time: `${h}:${m}`,
      date: d,
    };
  } catch (e) {
    console.error(e);
  }
};

export class DateTypeStringHelper {
  private _dateIntervalString: string;
  public dateTime: DateTimeObject;

  constructor(
    dateIntervalString: string,
    {
      formatter,
    }: { formatter: (dtString: string) => DateTimeObject | undefined } = {
      formatter: defaultDateTimeFormatter,
    }
  ) {
    this._dateIntervalString = dateIntervalString;
    const formattedDate = formatter(dateIntervalString);

    if (formattedDate) {
      this.dateTime = formattedDate;
      return;
    }

    this.dateTime = {
      date: '',
      time: '',
    };
  }
}
